export const AP_MAC_ACL_SECTION_EVENT =
	'canvas-agent:ap-mac-acl:section';
export const AP_MAC_ACL_FOCUS_EVENT =
	'canvas-agent:ap-mac-acl:focus';
export const AP_MAC_ACL_FILTER_EVENT =
	'canvas-agent:ap-mac-acl:filter';
export const AP_MAC_ACL_CREATE_MODAL_EVENT =
	'canvas-agent:ap-mac-acl:create-modal';
export const AP_MAC_ACL_EDIT_MODAL_EVENT =
	'canvas-agent:ap-mac-acl:edit-modal';
export const AP_MAC_ACL_DELETE_MODAL_EVENT =
	'canvas-agent:ap-mac-acl:delete-modal';
